/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import clamp from 'clamp';

import SnippetModel from 'cio/models/snippet';
import { liquidTag } from 'cio/helpers/liquid-tag';

interface SnippetItemArgs {
  snippet: SnippetModel;
}

export default class SnippetItem extends Component<SnippetItemArgs> {
  get liquidCode() {
    return `{{${liquidTag(['snippets', this.args.snippet.name])}}}`;
  }

  @action
  truncateSnippetValue(element: HTMLElement) {
    clamp(element, { clamp: 2 });
  }
}
